import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import emailjs from 'emailjs-com';
import styled from 'styled-components';
import data from '../Assets/data.json';
import 'bootstrap/dist/css/bootstrap.min.css';

const Container = styled.div`
  display: block;
  min-height: 80vh;
  min-width: 100vw;
  
  @media(max-width: 768px) {
    padding: 15% 2rem
  }
  
  @media(min-width: 769px) {
    padding: 10rem 21%;
  }
`;

const ContactForm = () => {
    const [validated, setValidated] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');

    const clearForm = () => {
        setValidated(false);
        setFirstName('');
        setLastName('');
        setEmail('');
        setPhone('');
        setMessage('');
    }

    const handleSubmit = (event) => {
        const form = event.currentTarget;

        event.preventDefault();
        setValidated(true);

        if (form.checkValidity() === false) {
            event.stopPropagation();
        } else {
            emailjs.sendForm('service_cw8fpvw', 'template_zlrt9vo', form, 'user_b5FziT3t3u1TgqCAS6hd7').then((result) => {
                clearForm();
            }, (error) => {
            });
        }

        setValidated(true);
    }

    return (
        <Container>
            <Form noValidate validated={validated} className="contact-form" onSubmit={handleSubmit}>
                <Form.Group controlId="groupFirstName">
                    <Form.Label>{data.contactForm.firstName}</Form.Label>
                    <Form.Control required name="first-name" type="text" placeholder="Jan" value={firstName}
                                  onChange={(e) => (setFirstName(e.target.value))}/>
                    <Form.Control.Feedback type="invalid">{data.contactForm.firstNameFeedback}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group controlId="groupLastName">
                    <Form.Label>{data.contactForm.lastName}</Form.Label>
                    <Form.Control required name="last-name" type="text" placeholder="Kowalski" value={lastName}
                                  onChange={(e) => (setLastName(e.target.value))}/>
                    <Form.Control.Feedback type="invalid">{data.contactForm.lastNameFeedback}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group controlId="groupEmail">
                    <Form.Label>{data.contactForm.email}</Form.Label>
                    <Form.Control required name="email-address" type="email" placeholder="jan.kowalski@mail.com"
                                  value={email} onChange={(e) => (setEmail(e.target.value))}/>
                    <Form.Control.Feedback type="invalid">{data.contactForm.emailFeedback}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group controlId="groupPhone">
                    <Form.Label>{data.contactForm.phone}</Form.Label>
                    <Form.Control required name="phone-number" type="text" placeholder="123 456 789" value={phone}
                                  onChange={(e) => (setPhone(e.target.value))}/>
                    <Form.Control.Feedback type="invalid">{data.contactForm.phoneFeedback}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group controlId="groupTextarea">
                    <Form.Label>{data.contactForm.message}</Form.Label>
                    <Form.Control as="textarea" name="message" rows={3} value={message}
                                  onChange={(e) => (setMessage(e.target.value))}/>
                </Form.Group>

                <Button type="submit">{data.contactForm.submit}</Button>
            </Form>
        </Container>
    );
};

export default ContactForm;
